import React, { useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { ModalWrapper, ModalContent } from './styles';
var Modal = function (_a) {
    var children = _a.children, show = _a.show, setShow = _a.setShow, noExit = _a.noExit, width = _a.width, style = _a.style;
    var sideMenuCollapsed = useContext(ThemeContext).sideMenuCollapsed;
    useEffect(function () {
        if (show && !noExit) {
            // document.getElementById('root').style.overflow = 'hidden';
            document.addEventListener('keydown', function (e) {
                if (e.keyCode === 27) {
                    setShow();
                }
            });
        }
        return function () {
            if (document) {
                var root = document.getElementById('root');
                if (root)
                    root.style.overflow = '';
            }
        };
        // eslint-disable-next-line
    }, [show, noExit]);
    return (React.createElement(ModalWrapper, { id: "modal", className: show ? 'is_open' : 'is_closed', sideMenuCollapsed: sideMenuCollapsed, onClick: function (e) {
            if (!noExit) {
                e.stopPropagation();
                setShow();
            }
        } },
        React.createElement(ModalContent, { id: "modalContent", style: style, width: width, onClick: function (e) {
                e.stopPropagation();
            } }, children)));
};
export default Modal;
